var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "応募者管理＿テンプレート設定",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "medium-6 cell" }, [
            _c(
              "button",
              {
                staticClass: "float-right boss-button boss-button-new",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "settingMessageTemplateRegister",
                    })
                  },
                },
              },
              [
                _c("span", { staticClass: "boss-icon-new" }),
                _vm._v(" "),
                _c("span", { staticClass: "boss-button-new-text" }, [
                  _vm._v("テンプレートを追加する"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.templates.length > 0
          ? _c("table", { staticClass: "unstriped hover boss-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "boss-table-head-center" }, [
                    _vm._v("\n            テンプレート名\n          "),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "boss-table-head-center" }, [
                    _vm._v("\n            件名\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-update" },
                    [_vm._v("\n            最終更新者\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-operation" },
                    [_vm._v("\n            編集\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-copy" },
                    [_vm._v("\n            コピー\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-operation" },
                    [_vm._v("\n            削除\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-display-change",
                    },
                    [
                      _c("div", { staticClass: "pega-relative" }, [
                        _vm._v(
                          "\n              テンプレートへの表示/非表示\n              "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content:
                                    "非表示にすると「テンプレート」に反映されません",
                                },
                                expression:
                                  "{ content: '非表示にすると「テンプレート」に反映されません'}",
                              },
                            ],
                            staticClass: "pega-circle small-right-top",
                          },
                          [_vm._v("?")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.templates, function (template, i) {
                  return _c("tr", { key: i }, [
                    _c(
                      "td",
                      {
                        staticClass: "boss-table-data",
                        attrs: { "data-test": "template-name" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(template.name) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "boss-table-data",
                        attrs: { "data-test": "template-subject" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(template.subject) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "boss-table-data",
                        attrs: { "data-test": "template-modified" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(template.modified) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "boss-table-data" }, [
                      _c("button", {
                        staticClass: "boss-icon-pencil",
                        attrs: { "data-test": "template-edit" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "settingMessageTemplateEdit",
                              params: { id: template.id },
                            })
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "boss-table-data" }, [
                      _c(
                        "div",
                        {
                          attrs: { "data-test": "template-copy" },
                          on: {
                            click: function ($event) {
                              return _vm.doCopy(template.id)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "boss-icon boss-icon-copy-regular boss-icon-copy",
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "boss-table-data",
                        attrs: { "data-test": "template-remove" },
                        on: {
                          click: function ($event) {
                            return _vm.doRemove(template.id)
                          },
                        },
                      },
                      [_c("button", { staticClass: "boss-icon-trash" })]
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "boss-table-data" }, [
                      _c("div", { staticClass: "switch toggle-switch" }, [
                        _c("input", {
                          staticClass: "toggle-input",
                          attrs: {
                            id: "toggle-" + template.id,
                            "data-test": "template-display",
                            type: "checkbox",
                          },
                          domProps: { checked: template.isDisplay },
                          on: {
                            change: function ($event) {
                              return _vm.changeDisplay(
                                template.id,
                                template.isDisplay
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "toggle-label",
                          attrs: { for: "toggle-" + template.id },
                        }),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _c(
              "div",
              { staticClass: "grid-x grid-margin-y align-center margin-top-2" },
              [
                _c("span", { staticClass: "cell medium-4 subheader" }, [
                  _vm._v("テンプレートが作成されていません。"),
                ]),
              ]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-6 cell" }, [
      _c("p", [
        _vm._v(
          "応募者へのメッセージ作成画面で使用するテンプレートを設定します。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }